import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import Splide from '@splidejs/splide';
import AOS from 'aos';
import Alpine from 'alpinejs'
import SwupGtmPlugin from '@swup/gtm-plugin';

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const swup = new Swup({
  plugins: [new SwupBodyClassPlugin(), new SwupGtmPlugin()],
}); 

// Events
swup.hooks.on('content:replace', function(){
  scroll(0,0);
  init();
});

document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
  // console.log(isMobile);
  
});


// Start Apline after swup so it works correctly
window.Alpine = Alpine
Alpine.start();


function loadIntros() {
  if(document.querySelector('.flyers')) {
    setTimeout(()=> {
      document.querySelector('.show').classList.remove('out');
    }, 500);
    setTimeout(()=> {
      document.querySelector('.and').classList.remove('out');
    }, 600);
    setTimeout(()=> {
      document.querySelector('.tell').classList.remove('out');
    }, 700);
    setTimeout(()=> {
      document.querySelector('.cookie').classList.remove('out');
    }, 900);
  }
}

function loadFlodeskScript() {
  l('loadFlodeskScript');
  if(document.querySelector('#mailinglist script')) {
    let jsCode = document.querySelector('#mailinglist script').innerText;
    let jsFun = Function(jsCode);
    jsFun();
  }
}

function setMainHeight() {
  l('setMainHeight');
  let navH = document.querySelector('.header').clientHeight
  // document.body.style.paddingTop = navH + 'px';
  if(document.querySelector('.event_intro')) {
    document.querySelector('.event_intro').style.height = window.innerHeight - (50 + navH) + 'px';
  }
}
setMainHeight();

window.addEventListener('resize', function() {
  setMainHeight();
});

window.addEventListener('scroll', function() {
  if (window.scrollY > 200) {
    document.body.setAttribute('data-scrolled', '');
  } else {
    document.body.removeAttribute('data-scrolled', '');
  }

  if (window.scrollY > (window.innerHeight - 200)) {
    document.body.setAttribute('data-fullwindowscroll', '');
  } else {
    document.body.removeAttribute('data-fullwindowscroll', '');
  }

});

function filterView() {

  if(window.location.pathname.indexOf('/location/') > -1 ) {
    document.body.setAttribute('data-layout', 'list');
    sortEventList();
  }

  if(window.location.pathname == '/events') {
    document.body.setAttribute('data-layout', 'grid');
  }

  if(!!document.querySelector('.events_grid')) {
    document.querySelector('.events_grid').addEventListener('click', function(el){
      l('gridView')
      if(!document.querySelector('.events_grid').classList.contains('active')) {
        document.querySelector('.events_grid').classList.add('active');
        document.querySelector('.events_list').classList.remove('active');
        document.body.setAttribute('data-layout', 'grid');
      }
    });
  }

  if(!!document.querySelector('.events_list')) {
    document.querySelector('.events_list').addEventListener('click', function() {
      sortEventList();
      if(!document.querySelector('.events_list').classList.contains('active')) {
        document.querySelector('.events_list').classList.add('active');
        document.querySelector('.events_grid').classList.remove('active');
        document.body.setAttribute('data-layout', 'list');
      }
    });
  }
}

function sortEventList() {

  var toSort = document.querySelector('.eventlist ul').children;
  // l(toSort);
  toSort = Array.prototype.slice.call(toSort, 0);

  toSort.sort(function(a, b) {
      var aord = +a.dataset.date;
      var bord = +b.dataset.date;
      // two elements never have the same ID hence this is sufficient:
      return (aord > bord) ? 1 : -1;
  });

  var parent = document.querySelector('.eventlist ul');
  parent.innerHTML = "";

  for(var i = 0, l = toSort.length; i < l; i++) {
      parent.appendChild(toSort[i]);
  }

}

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  startSliders();
  cookieNotice();
  highlightActive();
  setMainHeight();
  aboutIntro();
  scrollToAnchor();
  loadIntros();
  filterView();
  updateEventBackground();
  loadFlodeskScript();
}

function aosInit() {
  AOS.init({
    duration: 450,
    once: false,
  });
}

function scrollToAnchor() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        // document.querySelector(this.getAttribute('href')).scrollIntoView({
        //     behavior: 'smooth'
        // });
        let yOffset = -100; 
        let y;
        
        if(this.getAttribute('href') != '#') {
          y = document.querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }
        
    });
  });
}

function aboutIntro() {
  let el = document.querySelector('.aboutintro h2');
  if(el) {
    let oldText = el.innerText.split(' ');
    l(oldText);
    let newText = '';
    oldText.forEach(word => {
      let newWord = '<span>' + word + ' </span>';
      newText += newWord;
    });
    el.innerHTML = newText;

    let btns = document.querySelectorAll('.aboutintro h2 span');
    function randomCol(){ 
      let colors = ['pink', 'blue', 'green'];
      return colors[Math.floor(Math.random() * (colors.length))];
    }
    l(randomCol());

    btns.forEach(item => {
      item.addEventListener('mouseover', function(){
        item.className = '';
        item.classList.add(randomCol());
      })
    })
  }
}


function highlightActive() {
  let btns = document.querySelectorAll('.header a');
  btns.forEach(el => {
    el.addEventListener('click', btn => {
      [].forEach.call(btns, function(el) {
        el.classList.remove('active');
      });
      btn.target.classList.add('active');
    });
  });
}


function startSliders() {
  if(document.querySelectorAll('.splide').length) { 
    let perPage = isMobile ? 1 : 2.5;
    let slider = document.querySelectorAll('.splide');
    let autoplay = isMobile ? 'pause' : 'play';
    slider.forEach(carousel => new Splide( carousel, {
      type: 'slide',
      focus  : 'left',
      autoplay: autoplay,
      interval: 4000,
      perPage: perPage,
      perMove: 1,
      arrows: true,
      pagination: false
    }).mount());
  }
}

function updateEventBackground() {
  l('updateEventBackground')
  if(window.location.pathname.indexOf('/events/') > -1) {
    let container = document.getElementById('swup');
    if(container.hasAttribute('data-bg')) {
      let color = container.dataset.bg;
      l('changed bg to ' + color);
      document.body.style.background = color;
      document.querySelector('.event_nav').style.background = color;
      document.querySelector('.header').style.background = color;
    } else {
      l('event colour not set');
      resetBackground();
    }
  } else {
    resetBackground();
  }
}


function resetBackground() {
  l('resetBackground');
  let color = '#FFFF99';
  document.body.style.background = color;
  document.querySelector('.header').style.background = color;
  if(!!document.querySelector('.event_nav')) {
    document.querySelector('.event_nav').style.background = color;
  }
  
}


function cookieNotice() {
  l('cookienotice');
  document.querySelector('.cookie_btn').addEventListener('click', setCookie);
}

function setCookie() {
  l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  document.querySelector('.cookie').classList.add('hidden');
}